function App() {
  return (
    <div className="flex h-screen items-center justify-center">
      <h1 className="text-2xl font-bold">
        Burrow landing page
      </h1>
    </div>
  );
}

export default App;
